import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import GlobalStyles from '@mui/material/GlobalStyles';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import ShopKeepApp from './shopkeep';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1a3a5c',
      light: '#4a6a8c',
      lighter: '#e8eef4',
    },
    secondary: {
      main: '#f50057',
    },
    success: { main: '#1b5e20', light: '#4caf50', lighter: '#e8f5e9' },
    error: { main: '#d32f2f', light: '#ef5350', lighter: '#ffebee' },
    warning: { main: '#ed6c02', light: '#ff9800', lighter: '#fff3e0' },
    info: { main: '#0288d1', light: '#03a9f4', lighter: '#e1f5fe' },
    sold: { main: '#1565c0', light: '#0288d1', lighter: '#e3f2fd' },
    inventory: {
      available: '#013a96',
      sold: '#003502',
    },
    brand: {
      gradientStart: '#1a3a5c',
      gradientEnd: '#0d1f3a',
    },
    accent: {
      main: '#ff7043',
      dark: '#e64a19',
      contrastText: '#fff',
      secondary: '#1565c0',
    },
    featureCards: [
      { start: '#1565c0', end: '#0d47a1' },   // Inventory — deep blue
      { start: '#00897b', end: '#00695c' },   // Channels — teal
      { start: '#5f1515', end: '#6e0404' },   // Expenses — dark gold
      { start: '#1b5e20', end: '#1b5e20' },   // Sales — green
      { start: '#7b1fa2', end: '#4a148c' },   // Reports — purple
      { start: '#546e7a', end: '#37474f' },   // Images — warm grey-blue
      { start: '#283593', end: '#1a237e' },   // AI Assistant — indigo
      { start: '#bf360c', end: '#8d2208' },   // Mileage — burnt orange
      { start: '#455a64', end: '#263238' },   // Import & Export — blue-grey
    ],
    common: { 
      white: '#fff', 
      black: '#000', 
      grey: '#f5f5f5',
      lightBlue: '#91d1ff',
    },
    sidebar: {
      gradientStart: '#1a3a5c',
      gradientEnd: '#0d1f3a',
    },
    footer: {
      main: '#2c3e50',
    },
    heading: {
      main: '#2c3e50',
    },
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
  },
  components: {
    MuiTableHead: {
      styleOverrides: {
        root: ({ theme }) => ({
          backgroundColor: theme.palette.sidebar.gradientStart,
        }),
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          color: '#fff',
          fontWeight: 700,
        },
      },
    },
  },
});

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalStyles styles={{ '.firebase-emulator-warning': { display: 'none' } }} />
        <BrowserRouter>
          <ShopKeepApp />
        </BrowserRouter>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
